import useLoadingStore from "../../store/useLoadingState";
import { StyledLoading } from "./style";

export const Loading = () => {
  const { loadingMessage } = useLoadingStore();
  return (
    <StyledLoading>
      <div className="loading-container">
        <span className="loading-circle" />
        <p className="loading-message">
          {loadingMessage ? loadingMessage : "LOADING..."}
        </p>
      </div>
    </StyledLoading>
  );
};
